import { useState } from "react";
import record from "../assets/dummy/DataRecord.json";
import WebPaging from "./CompPaging";
import { useMediaQuery } from "react-responsive";

function AboutRndRecord() {
  const [limit, setLimit] = useState(10); // eslint-disable-line no-unused-vars
  const [page, setPage] = useState(1);
  const offset = (page - 1) * limit;

  const [moreBtn, setMoreBtn] = useState(false);
  const [recordData, setrecordData] = useState(record.Rnd.slice(0).reverse()); // eslint-disable-line no-unused-vars

  const onMoreBtn = (doOpen) => {
    setMoreBtn(doOpen);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <div className="section-record">
          <h2 className="basic-title">R&amp;D 수행실적</h2>
          <div className="basic-subtitle">
            헬리오센의 R&amp;D 수행실적을 알려드립니다.
          </div>
          <div className="table-item table-name-item">
            <div className="table-year">수행 년도</div>
            <div className="table-name">사업명</div>
            <div className="table-company">기관명</div>
          </div>
          <div>
            <ul className="table-list">
              {record.Rnd.slice(0)
                .reverse()
                .slice(offset, offset + limit)
                .map((rnd) => (
                  <li className="table-item" key={rnd.id}>
                    <div className="table-year">{rnd.date}</div>
                    <div className="table-name">{rnd.title}</div>
                    <div className="table-company">{rnd.com}</div>
                  </li>
                ))}
            </ul>
          </div>
          <div>
            <WebPaging
              total={record.Rnd.length}
              limit={limit}
              page={page}
              setPage={setPage}
            />
          </div>
        </div>
      ) : (
        <div className="section-record">
          <h2 className="basic-title">R&amp;D 수행실적</h2>
          <div className="basic-subtitle">
            헬리오센의 R&amp;D 수행실적을 알려드립니다.
          </div>
          <div>
            <ul className="table-list rnd-table-list">
              {moreBtn ? (
                <>
                  {recordData.map((Rnd) => (
                    <li className="table-item" key={Rnd.id}>
                      <div className="mobile-table-top">
                        <div className="table-company">{Rnd.com}</div>
                        <div className="table-year">{Rnd.date}</div>
                      </div>
                      <div className="table-name">{Rnd.title}</div>
                    </li>
                  ))}
                  <li className="about-history-more">
                    <button
                      onClick={() => {
                        onMoreBtn(!moreBtn);
                      }}
                      className="about-history-btn on"
                    >
                      <span>접기</span>
                    </button>
                  </li>
                </>
              ) : (
                <>
                  {recordData.slice(record, 5).map((Rnd) => (
                    <li className="table-item" key={Rnd.id}>
                      <div className="mobile-table-top">
                        <div className="table-company">{Rnd.com}</div>
                        <div className="table-year">{Rnd.date}</div>
                      </div>
                      <div className="table-name">{Rnd.title}</div>
                    </li>
                  ))}
                  <li className="about-history-more">
                    <button
                      onClick={() => {
                        onMoreBtn(!moreBtn);
                      }}
                      className="about-history-btn"
                    >
                      <span>더보기</span>
                    </button>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default AboutRndRecord;
